import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, withStateHandlers } from 'recompose';
import {
  Button,
  ButtonToolbar,
  Glyphicon,
  Col,
  Clearfix,
  Row,
  Alert,
} from 'react-bootstrap';

import { lockPayPeriod } from '../actions';

const buttonClickPropTypes = {
  isClicked: PropTypes.bool.isRequired,
  setClicked: PropTypes.func.isRequired,
};

const withButtonState = withStateHandlers(
  (props) => { return { isClicked: false }; },
  {
    setClicked: (state, props) => {
      return () => { return { isClicked: true }; };
    },
  },
);

const propTypes = exact({
  eligibleForClose: PropTypes.bool.isRequired,
  selectedPayPeriod: PropTypes.object.isRequired,
  lockPayPeriodAction: PropTypes.func.isRequired,
  ...buttonClickPropTypes,
});

const LockPayPeriodButton = (props) => {
  const {
    eligibleForClose,
    selectedPayPeriod,
    lockPayPeriodAction,
  } = props;
  const payPeriodId = selectedPayPeriod.id;

  const { isClicked, setClicked } = props;

  const alertStyle = () => {
    if (eligibleForClose) {
      return 'success';
    }
    return 'danger';
  };

  const lockMessage = () => {
    if (eligibleForClose) {
      return 'Ready to lock!';
    }
    return 'All timesheets must be approved before the pay period can be locked';
  };

  const handleLockPayPeriod = async (paramPayPeriodId) => {
    setClicked();
    await lockPayPeriodAction(paramPayPeriodId);
    /* NOTE: Not calling clearClicked because component gets unmounted
      * Error occurs if unDisabling button if it's not there. */
  };

  return (
    <div>
      <Row>
        <Col xs={8}>
          <Alert bsStyle={alertStyle()}>
            <Clearfix>
              <h3 className="pull-left">
                {lockMessage()}
              </h3>
              <ButtonToolbar className="pull-right">
                <Button
                  disabled={!eligibleForClose || isClicked}
                  onClick={() => { handleLockPayPeriod(payPeriodId); }}
                >
                  <Glyphicon glyph="lock" style={{ marginRight: '0.5em' }} />
                  Lock Pay Period
                </Button>
              </ButtonToolbar>
            </Clearfix>
          </Alert>
        </Col>
      </Row>
    </div>
  );
};

LockPayPeriodButton.propTypes = propTypes;

const mapDispatchToProps = {
  lockPayPeriodAction: lockPayPeriod,
};

const withRedux = connect(null, mapDispatchToProps);
const enhance = compose(
  withRedux,
  withButtonState,
);
export default enhance(LockPayPeriodButton);
